(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["npd-pdp-experience"] && !Shopify.designMode) return;
  try {
    // MANGOAL PDP scoped pop v5 — operates ONLY on product.npd-three-screen-test and product.new-starvis-2-cam.
(() => {
  function initializePdpPop() {
  if (window.__npdPdpScopedPopV5) return;
  const root = document.querySelector('.npd-features[data-npd-pdp-page="product"][data-npd-pdp-template="newprudctdetail"],.npd-features[data-npd-pdp-page="product"][data-npd-pdp-template="newprudctdetail"]');
  if (!root) return;
  window.__npdPdpScopedPopV5 = true;

  const main = root.closest('main') || root.parentElement;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduceMotion.matches || !('IntersectionObserver' in window)) return;

  const seen = new WeakSet();
  const targets = new Set();
  const selector = [
    '.npd-feature','.npd-recording__channel','.npd-quality__pair figure',
    '.npd-night__compare','.npd-module__card','.npd-parking__visual',
    '.npd-parking__benefits > div','.npd-module__image','.npd-app__steps li',
    '.npd-wireless__stage','.npd-packing__item','.npd-video__card',
    '.npd-compare__scroll','.npd-module__inner > h2',
    '.npd-module__inner > .npd-module__intro',
    '.npd-pdp__inner > h2','.npd-pdp__inner > .npd-pdp__intro'
  ].join(',');

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const node = entry.target;
      observer.unobserve(node);
      if (!targets.has(node)) return;
      targets.delete(node);
      node.classList.add('npd-pdp-pop-shown');
    });
  }, { threshold: 0.04, rootMargin: '0px 0px -2% 0px' });

  function release(node) {
    observer.unobserve(node);
    targets.delete(node);
    node.classList.remove('npd-pdp-pop-ready','npd-pdp-pop-shown');
  }

  function prepare(scope) {
    if (reduceMotion.matches) return;
    const found = [...scope.querySelectorAll(selector)];
    found.forEach(node => {
      if (seen.has(node)) return;
      if (!node.closest('.npd-module,.npd-pdp')) return;
      if (node.matches('.npd-module__image') &&
          node.closest('.npd-module__card,.npd-packing__item,.npd-parking__visual,.npd-video__card')) return;
      seen.add(node);
      const rect = node.getBoundingClientRect();
      // Never hide an element that is already in the initial visible viewport.
      if (rect.bottom > 0 && rect.top < window.innerHeight) return;
      // Preserve already-interactive components such as comparison handles.
      node.classList.add('npd-pdp-pop-ready');
      targets.add(node);
      observer.observe(node);
    });
  }

  prepare(main);
  document.addEventListener('shopify:section:load', event => {
    if (main.contains(event.target)) prepare(event.target);
  });
  document.addEventListener('shopify:section:unload', event => {
    if (main.contains(event.target)) event.target.querySelectorAll(selector).forEach(release);
  });
  document.addEventListener('shopify:block:select', event => {
    const parent = event.target.closest('.npd-pdp-pop-ready');
    if (parent && main.contains(parent)) release(parent);
  });
  reduceMotion.addEventListener?.('change', () => {
    if (reduceMotion.matches) [...targets].forEach(release);
  });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePdpPop, { once:true });
  } else {
    initializePdpPop();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["std-pdp-experience"] && !Shopify.designMode) return;
  try {
    // MANGOAL PDP scoped pop v5 — operates ONLY on product.std-pdp-three-screen-test and product.new-starvis-2-cam.
(() => {
  function initializePdpPop() {
  if (window.__stdPdpScopedPopV5) return;
  const root = document.querySelector('.std-pdp-features[data-std-pdp-page="product"][data-std-pdp-template="newproductstandard"],.std-pdp-features[data-std-pdp-page="product"][data-std-pdp-template="newproductstandard"]');
  if (!root) return;
  window.__stdPdpScopedPopV5 = true;

  const main = root.closest('main') || root.parentElement;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduceMotion.matches || !('IntersectionObserver' in window)) return;

  const seen = new WeakSet();
  const targets = new Set();
  const selector = [
    '.std-pdp-feature','.std-pdp-recording__channel','.std-pdp-quality__pair figure',
    '.std-pdp-night__compare','.std-pdp-module__card','.std-pdp-parking__visual',
    '.std-pdp-parking__benefits > div','.std-pdp-module__image','.std-pdp-app__steps li',
    '.std-pdp-wireless__stage','.std-pdp-packing__item','.std-pdp-video__card',
    '.std-pdp-compare__scroll','.std-pdp-module__inner > h2',
    '.std-pdp-module__inner > .std-pdp-module__intro',
    '.std-pdp__inner > h2','.std-pdp__inner > .std-pdp__intro'
  ].join(',');

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const node = entry.target;
      observer.unobserve(node);
      if (!targets.has(node)) return;
      targets.delete(node);
      node.classList.add('std-pdp-pop-shown');
    });
  }, { threshold: 0.04, rootMargin: '0px 0px -2% 0px' });

  function release(node) {
    observer.unobserve(node);
    targets.delete(node);
    node.classList.remove('std-pdp-pop-ready','std-pdp-pop-shown');
  }

  function prepare(scope) {
    if (reduceMotion.matches) return;
    const found = [...scope.querySelectorAll(selector)];
    found.forEach(node => {
      if (seen.has(node)) return;
      if (!node.closest('.std-pdp-module,.std-pdp')) return;
      if (node.matches('.std-pdp-module__image') &&
          node.closest('.std-pdp-module__card,.std-pdp-packing__item,.std-pdp-parking__visual,.std-pdp-video__card')) return;
      seen.add(node);
      const rect = node.getBoundingClientRect();
      // Never hide an element that is already in the initial visible viewport.
      if (rect.bottom > 0 && rect.top < window.innerHeight) return;
      // Preserve already-interactive components such as comparison handles.
      node.classList.add('std-pdp-pop-ready');
      targets.add(node);
      observer.observe(node);
    });
  }

  prepare(main);
  document.addEventListener('shopify:section:load', event => {
    if (main.contains(event.target)) prepare(event.target);
  });
  document.addEventListener('shopify:section:unload', event => {
    if (main.contains(event.target)) event.target.querySelectorAll(selector).forEach(release);
  });
  document.addEventListener('shopify:block:select', event => {
    const parent = event.target.closest('.std-pdp-pop-ready');
    if (parent && main.contains(parent)) release(parent);
  });
  reduceMotion.addEventListener?.('change', () => {
    if (reduceMotion.matches) [...targets].forEach(release);
  });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePdpPop, { once:true });
  } else {
    initializePdpPop();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
